import TabsSubCategory from './tabsSubCategory'

const tabsSubCategory = new TabsSubCategory()
tabsSubCategory.init()
